import { Box, Tooltip } from "@mui/material"
import { Images } from "./Images"
import { Info } from "./Info"
import { Close } from "@mui/icons-material"
import { useContext } from "react"
import { ToolContext } from "../../../../../../../../core/context/ToolContext"
import { Setup } from "./Setup"
import { CustomStyles } from "../../../../../../../../core/global/realproperty/styles/CustomStyles"

export const PropCustomize = ({ t_form, leftBar, opentxtfld, params }) => {
    const { salespage_state } = useContext(ToolContext)
    const { showPicker, open_i, error, validateNum } = salespage_state;
    const handleOpenText = (type) => {
        opentxtfld.set(type)
        leftBar.set(true)
        open_i.set(false)
    }
    const handleInclusion = (type) => {
        open_i.set(type)
    }

    const handleChange = (e, i,) => {
        const { name, value } = e.target

        const inputs = { ...t_form.data.styles }
        if (name === 'bestfor_items' || name === 'feature_items') {
            inputs.names[name][i].value = value
            inputs.names[name][i].stat = value === '' ? true : false
            inputs.names[name][i].msg = value === '' ? 'This field is required.' : ''
        }
        if (name === 'first_button_label' || name === 'first_button_link') {
            if (name === 'first_button_label') inputs.names.buttons.first.label = value
            if (name === 'first_button_link') inputs.names.buttons.first.link = value
            inputs.names.buttons.first.msg = value === '' ? 'This field is required.' : ''
            inputs.names.buttons.first.stat = value === '' ? true : false
        } else if (name === 'second_button_label' || name === 'second_button_link') {
            if (name === 'second_button_label') inputs.names.buttons.second.label = value
            if (name === 'second_button_link') inputs.names.buttons.second.link = value
            inputs.names.buttons.second.msg = value === '' ? 'This field is required.' : ''
            inputs.names.buttons.second.stat = value === '' ? true : false
        } else {
            inputs.names[name].value = value
            inputs.names[name].msg = value === '' ? 'This field is required.' : ''
            inputs.names[name].stat = value === '' ? true : false
        }
        t_form.set({ ...t_form.data, inputs })
    }

    const dsg = t_form.data.styles
    const fileHandler = (f, e) => {
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.onloadend = () => {
            const i = { ...dsg.names.images }
            file = e.target.files[0];
            i[f] = { value: file, object: URL.createObjectURL(file), name: file.name, type: file.type.split('/')[0], size: file.size, updated: true, stat: false, msg: '' }
            t_form.set({ ...t_form.data, styles: { ...t_form.data.styles, names: { ...dsg.names, images: i } } })
        };
        reader.readAsDataURL(file);
    }
    const classes = CustomStyles()
   
    return (
        <Box display="flex" width="100%" height="100%">
            {
                leftBar.data ?
                    <Box width={300} height="100%" bgcolor="#E8EEF5" px={1}>
                        <Box display="flex" justifyContent="end" pt={10}>
                            <Box className={classes.text}>Text <Box ml={1} fontSize={20} color="red">*</Box></Box>
                            <Tooltip title="Close" arrow>
                                <Close sx={{ cursor: "pointer", fontSize: 20, color: '#00000' }} onClick={() => leftBar.set(false)} />
                            </Tooltip>
                        </Box>
                        <Box pt={2}>
                            <Setup validateNum={validateNum} params={params} opentxtfld={opentxtfld} t_form={t_form} handleChange={handleChange} showPicker={showPicker} open_i={open_i} handleInclusion={handleInclusion} />
                        </Box>
                    </Box>
                    : false
            }
            <Box width="100%" display="flex" pt={8} className="overflowY" px={4}>
                <Box width="60%">
                    <Info error={error} t_form={t_form} fileHandler={fileHandler} handleChange={handleChange} handleOpenText={handleOpenText} leftBar={leftBar.data} opentxtfld={opentxtfld.data} open_i={open_i} handleInclusion={handleInclusion} />
                </Box>
                <Box width="40%">
                    <Images params={params} t_form={t_form} fileHandler={fileHandler} error={error} />
                </Box>
            </Box>
        </Box>
    )
}